import React, { Component } from 'react'
import Header from '../components/header'
import Icon from '../components/icon'
import Resume from '../components/resume'
import { BELIZ, SILVER } from '../utils/colors'


class Work extends Component {

    render() {
        return (
            <div className='container'>

                <Header title='Experience' subtitle='Some of the goods.' />

                <Resume />

                <div className='container' style={{padding: '2em', border: `solid 8px ${BELIZ}`}}>
                    <div className='level columns'>
                        <div className='column is-one-third' style={{color: `${SILVER}`}}>
                            <div>
                                <p>{`Created professional software using React, React Native, Nodejs, jQuery, Socket.io - to name a few. I also enjoy smaller javascript frameworks like Re:dom, Mithril.js, and Maquette.`}</p>
                                <p>{`I've used many other open source frameworks that aid development such as Realm Database, Sequelize, Express, and Swagger.`}</p>
                                <p>{`DevOps tools such as Docker, Travis-CI, and Fastlane are common in my projects.`}</p>
                                <p>Check out my resume for a complete list of work and experience!  Some frameworks and APIs I{`'`}ve used <span role='img' aria-label='point-right' className='finger'>👉</span>.</p>
                            </div>
                        </div>
                        <div className='column is-two-thirds has-text-centered'>
                            <div className='level is-mobile'>
                                <div/>
                                <Icon name='fab fa-react'/>
                                <Icon name='fab fa-angular'/>
                                <Icon name='fab fa-node'/>
                                <div/>
                            </div>
                            <hr style={{border: `solid 2px ${BELIZ}`}}/>
                            <div className='level is-mobile'>
                                <div/>
                                <Icon name='fab fa-js-square'/>
                                <Icon name='fab fa-npm'/>
                                <Icon name='fab fa-stripe'/>
                                <div/>
                            </div>
                            <hr style={{border: `solid 2px ${BELIZ}`}}/>
                            <div className='level is-mobile'>
                                <div/>
                                <Icon name='fab fa-app-store'/>
                                <Icon name='fab fa-google-play'/>
                                <Icon name='fab fa-amazon'/>
                                <div/>
                            </div>
                            <hr style={{border: `solid 2px ${BELIZ}`}}/>
                            <div className='level is-mobile'>
                                <div/>
                                <Icon name='fab fa-facebook'/>
                                <Icon name='fab fa-docker'/>
                                <Icon name='fas fa-database'/>
                                <div/>
                            </div>

                        </div>
                    </div>
                </div>

            </div>
        )
    }

}


export default Work



// WEBPACK FOOTER //
// ./src/screens/work.js